<div
    *ngIf="scoreInfo"
    class="container"
>
    <app-page-title
        *ngIf="brandId === BrandEnum.CELPIP"
        [title]="'Your celpip scores'"
    ></app-page-title>
    <app-page-title
        *ngIf="brandId === BrandEnum.CAEL"
        [title]="'Online score report'"
    ></app-page-title>
    <div class="row">
        <div class="col-md-12">
            <div *ngIf="brandId === BrandEnum.CAEL">
                <p>This score report has been created for online confirmation of identity and scores only. It is not valid in printed form.</p>
            </div>
            <div *ngIf="brandId === BrandEnum.CELPIP">
                <div *ngIf="!launchSRDownload; else showDownloadButton">
                    <p>
                        <strong>
                            This score report has been created for online confirmation of identity and scores
                            only. It is not valid in printed form.
                        </strong>
                    </p>
                </div>
                <ng-template #showDownloadButton>
                    <p>
                        <strong>
                            Your CELPIP scores are listed below. If you wish to submit your scores to an organization (i.e. Immigration,
                            Refugees and Citizenship Canada),
                            please download a copy of your CELPIP Official Score Report by clicking on the Download CELPIP Official
                            Score Report button.
                        </strong>
                    </p>
                    <br />
                    <a
                        class="btn btn-primary"
                        (click)="downloadCelpipScoreReport()"
                    >Download CELPIP Official Score Report</a>
                </ng-template>
            </div>
        </div>
    </div>

    <div
        *ngIf="logo"
        class="row"
    >
        <div class="col-md-12 text-center">
            <div *ngIf="!launchSRDownload">
                <img
                    [src]="logo"
                    alt="{{scoreInfo.regInfo.testTypeName}}"
                />
            </div>
            <div
                *ngIf="launchSRDownload"
                class="text-center"
            >
                <h4>
                    {{scoreInfo.regInfo.testTypeName}} Test Results
                </h4>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <h4>Test Taker Information</h4>
            <div class="row">
                <div class="col-md-6">
                    <p style="text-transform: uppercase">{{scoreInfo.personalInfo.lastName}}, {{scoreInfo.personalInfo.firstName}} {{scoreInfo.personalInfo.middleName}}</p>
                    <p>Date of Birth: <strong>{{scoreInfo.personalInfo.birthDate | date:'longDate' }}</strong></p>
                    <p>Registration Number: <strong>{{scoreInfo.regInfo.regId}}</strong></p>
                    <p>PIN: <strong>{{scoreInfo.regInfo.pin}}</strong></p>
                </div>
                <div class="col-md-6">
                    <p>Test Site: <strong>{{scoreInfo.regInfo.testCentreName}}</strong></p>
                    <p>Test Location: <strong>{{scoreInfo.regInfo.testCentreLocation}}</strong></p>
                    <p>Test Date: <strong>{{scoreInfo.regInfo.testDateTime| date:'medium' }}</strong></p>
                </div>
            </div>
        </div>
        <div
            class="row"
            *ngIf="(scoreInfo.areScoresReleased == false && scoreInfo.regStatusEnum === RegStatusEnum.ScorePublished) || (scoreInfo.regStatusEnum === RegStatusEnum.ScoreInvalidate); else noProblemRecord"
        >
            <div class="col-md-12">
                <h4>There's a problem with this registration.</h4>
            </div>
        </div>
        <ng-template
            #noProblemRecord
            class="row"
        >
            <div class="col-md-12">
                <div *ngIf="scoreInfo.components.length > 0">
                    <h4>Test Results</h4>
                    <div *ngIf="invalidScoreForIRCC">
                        <div class="col-md-9 invalid-score mx-auto">
                            This score report is not valid for the purpose of applying to Immigration, Refugees and Citizenship Canada (IRCC).
                        </div>
                    </div>
                    <br />
                    <table class="table table-striped table-bordered text-center">
                        <thead>
                            <tr>
                                <th>Component</th>
                                <th class="th-level"><span *ngIf="brandId === BrandEnum.CELPIP">CELPIP Level</span> <span *ngIf="brandId === BrandEnum.CAEL">CAEL Level</span></th>
                                <th><span *ngIf="brandId === BrandEnum.CELPIP">CELPIP</span> <span *ngIf="brandId === BrandEnum.CAEL">CAEL</span> Descriptor</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let component of scoreInfo.components">
                                <td>
                                    <p><strong>{{component.componentName}}</strong></p>
                                    <h5 class="d-block d-sm-none">Level<br />{{component.levelName}}</h5>
                                </td>
                                <td class=" td-level">
                                    <p>{{component.levelName}}</p>
                                </td>
                                <td class="text-left">
                                    <p><u>{{component.levelDescriptor}}</u></p>
                                    <div *ngIf="component.componentName === 'Speaking' || component.componentName === 'Writing'">
                                        <div [innerHTML]="component.detailDescriptor | safe: 'html'"></div>
                                    </div>
                                    <div *ngIf="component.componentName !== 'Speaking' && component.componentName !== 'Writing' && component.detailDescriptorList">
                                        <ul
                                            [innerHTML]="component.detailDescriptorList | safe: 'html'"
                                            class="descriptor-list"
                                        >
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div>
                        <a
                            class="text-left"
                            href="{{testLevelDescriptorUrl}}"
                            target="_blank"
                        >What do your scores mean?</a>
                    </div>
                </div>
                <div
                    *ngIf="brandId === BrandEnum.CELPIP && !launchSRDownload && scoreInfo.components.length > 0"
                    class="mt-3"
                >
                    <h4>CELPIP Level and Canadian Language Benchmarks (CLB)</h4>
                    <table class="table table-bordered table-striped">
                        <thead>
                            <tr>
                                <th>CELPIP Level</th>
                                <th>CELPIP Descriptor</th>
                                <th>CLB Level</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let scoreLevel of scoreInfo.scoreLevels">
                                <td>{{scoreLevel.name}}</td>
                                <td>{{scoreLevel.descriptor}}</td>
                                <td>{{scoreLevel.foreignSystemLevelName}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div *ngIf="scoreInfo.components.length == 0">
                    <strong>The scores are not available for this test registration.</strong>
                </div>
            </div>
        </ng-template>
    </div>

    <app-modal
        #downloadErrorModal
        title="Error"
        body="Unable to process. This download score service is only available for up to two years from the date of your CELPIP Test."
    >
    </app-modal>
